import React, { useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import ValidadorImagenFactura from '../../Components/Facturas/ValidadorImagenFactura';

/**
 * Página de prueba para el validador de imágenes de facturas
 */
const ValidarFacturaIA = () => {
  const [imagenValida, setImagenValida] = useState(null);
  const [metricasImagen, setMetricasImagen] = useState(null);

  /**
   * Handler cuando la imagen es válida
   */
  const handleImagenValida = (file, metricas) => {
    //console.log('✅ Imagen válida:', file.name);
    //console.log('📊 Métricas:', metricas);
    setImagenValida(file);
    setMetricasImagen(metricas);
  };

  /**
   * Handler cuando la imagen es inválida
   */
  const handleImagenInvalida = (errores) => {
    //console.log('❌ Imagen inválida:', errores);
    setImagenValida(null);
    setMetricasImagen(null);
  };

  /**
   * Handler cuando el backend valida la imagen
   */
  const handleValidacionBackend = (respuesta, file) => {
    //console.log('🌐 Validación del backend:', respuesta);
    //console.log('📄 Archivo:', file.name);
    
    if (respuesta.valida) {
      //console.log('✅ Imagen validada por el servidor');
      // Aquí podrías continuar con el siguiente paso (extracción OCR)
    } else {
      //console.log('❌ Imagen rechazada por el servidor');
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        {/* Breadcrumb */}
        <Row>
          <Col xs={12}>
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">Validar Factura con IA</h4>
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a href="/facturas">Facturas</a>
                  </li>
                  <li className="breadcrumb-item active">Validar con IA</li>
                </ol>
              </div>
            </div>
          </Col>
        </Row>

        {/* Contenido */}
        <Row>
          <Col lg={8}>
            {/* Validador de imagen */}
            <ValidadorImagenFactura
              onImagenValida={handleImagenValida}
              onImagenInvalida={handleImagenInvalida}
              onValidacionBackend={handleValidacionBackend}
              maxSizeMB={10}
              minWidth={800}
              minHeight={600}
              minMegapixels={0.48}
            />
          </Col>

          <Col lg={4}>
            {/* Información y ayuda */}
            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">
                  <i className="ri-information-line me-2"></i>
                  Información
                </h5>
              </CardHeader>
              <CardBody>
                <h6 className="fs-14 mb-2">¿Cómo tomar una buena foto?</h6>
                <ul className="fs-13 text-muted mb-3">
                  <li>Usa buena iluminación natural</li>
                  <li>Coloca la factura sobre una superficie plana</li>
                  <li>Toma la foto desde arriba, perpendicular</li>
                  <li>Asegúrate que el texto sea legible</li>
                  <li>Evita sombras y reflejos</li>
                </ul>

                <h6 className="fs-14 mb-2">Requisitos técnicos</h6>
                <ul className="fs-13 text-muted mb-3">
                  <li>Tamaño mínimo: 800x600px</li>
                  <li>Megapixels mínimos: 0.48MP</li>
                  <li>Tamaño máximo: 10MB</li>
                  <li>Formatos: JPG, PNG, WEBP</li>
                </ul>

                {imagenValida && metricasImagen && (
                  <>
                    <hr />
                    <h6 className="fs-14 mb-2 text-success">
                      <i className="ri-check-circle-line me-1"></i>
                      Imagen Lista
                    </h6>
                    <div className="fs-13 text-muted">
                      <p className="mb-1">
                        <strong>Archivo:</strong> {metricasImagen.nombre}
                      </p>
                      <p className="mb-1">
                        <strong>Dimensiones:</strong> {metricasImagen.width}x{metricasImagen.height}px
                      </p>
                      <p className="mb-1">
                        <strong>Tamaño:</strong> {metricasImagen.size_mb}MB
                      </p>
                      <p className="mb-0">
                        <strong>Formato:</strong> {metricasImagen.formato}
                      </p>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>

            {/* Próximos pasos */}
            {imagenValida && (
              <Card className="border-success">
                <CardBody>
                  <h6 className="fs-14 mb-2">
                    <i className="ri-arrow-right-circle-line me-1"></i>
                    Próximos Pasos
                  </h6>
                  <p className="fs-13 text-muted mb-2">
                    La imagen ha sido validada correctamente. Ahora puedes:
                  </p>
                  <ol className="fs-13 text-muted mb-0 ps-3">
                    <li>Enviar al backend para validación adicional</li>
                    <li>Extraer datos con OCR + IA</li>
                    <li>Revisar y confirmar datos extraídos</li>
                    <li>Guardar factura en el sistema</li>
                  </ol>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ValidarFacturaIA;
